module.exports = __webpack_public_path__ + "img/kp2.f8bcb864.png";